<template>
  <el-dialog :title="info.itmeCategory || info.categoryName" :visible="true" @close="handleClose" width="700px">
    <div class="dialog-header">
      <p>适用商品</p>
      <el-button type="primary" @click="addGoods()" v-if="isEdit">适用商品</el-button>
    </div>
    <el-table
      :data="listData"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        label="商品名称"
        prop="itemName"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="商品编码"
        prop="itemCode"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" align="right" v-if="isEdit">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="delGoods(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="itemInfos.length"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <div slot="footer" class="dialog-footer" v-if="isEdit">
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
    <goods-dialog  v-if="visibleGoods" @update:visibleGoodsMessage="visibleGoodsMessage"></goods-dialog>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import GoodsDialog from './goodsDialog'

export default {
  name: 'lookDialog',
  components: { GoodsDialog },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      listState: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      listData: [],
      itemInfos: [],
      visibleGoods: false
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getProductDetail', 'getProductSave']),
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.handleChangePage()
    },
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleChangePage()
    },
    handleSearch () {
      const params = {
        pageNo: this.listState.pageNo,
        pageSize: 1000,
        categoryCode: this.info.itemCategoryCode || this.info.categoryCode
      }
      this.getProductDetail(params).then(res => {
        this.itemInfos = res.list || []
        this.handleChangePage()
      })
    },
    handleClose () {
      this.$emit('update:handleProductClose', false)
    },
    addGoods () {
      this.visibleGoods = true
    },
    visibleGoodsMessage (playload) {
      let { visibleGoods, selectData, type } = playload
      if (!type) {
        this.visibleGoods = visibleGoods
        return
      }
      this.visibleGoods = visibleGoods
      const res = new Map()
      this.itemInfos = this.itemInfos.concat(selectData).filter((item) => !res.has(item.itemCode) && res.set(item.itemCode, 1))
      this.handleChangePage()
      this.$forceUpdate()
    },
    delGoods (index, row, itemIndex) {
      this.$confirm('是否确认删除', '删除提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { pageSize, pageNo } = this.listState
        await this.itemInfos.splice((pageSize * (pageNo - 1)) + index, 1)
        this.handleChangePage()
      }).catch(() => {
        // 取消删除
      })
    },
    handleChangePage () {
      const pageSize = this.listState.pageSize || 10
      const pageNo = this.listState.pageNo || 1
      const total = this.itemInfos.length
      if (total % pageSize === 1) {
        const lastPage = (total + pageSize - 1) / pageSize
        if (pageNo === lastPage) {
          this.listState.pageNo = pageNo - 1
        }
      }
      this.listData = this.$lodash.cloneDeep(this.itemInfos).splice(pageSize * (pageNo - 1), pageSize)
    },
    handleSubmit () {
      let List = this.itemInfos.map(item => {
        item.categoryCode = this.info.categoryCode
        item.categoryName = this.info.categoryName
        return item
      })
      let params = {
        categoryItemAddVos: List,
        categoryCode: this.info.categoryCode
      }
      this.getProductSave(params).then(res => {
        if (res.success) {
          this.$message.success('操作成功')
          this.$emit('update:handleProductClose', false)
          this.$parent.handleSearch()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-header{
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
